<template>
  <div class="product">
    <p class="title">专注微信解决学校日常场景      依角色提供精准服务</p>
    <div class="content">
      <div class="left">
        <feature-nav-menu v-for="(item, index) in navMenus" :key="index" :title="item.title" :features="item.features"></feature-nav-menu>
      </div>
      <div class="right">
        <div class="header">
          <div>
            <img :src="featureImgs[0]" width="80px"/>
            <div>
              <p>
                <span>成绩管理及分析</span><br>
                <span>使用对象：学生、老师、家长、校友</span>
              </p>
            </div>
          </div>
          <div style="width:1px;height:60px;margin: 10px;background-color: #eee"></div>
          <div>
            <span>
              老师发布成绩，家长阅读情况一目了然，并可自动分析全班成绩分布
            小助手将成绩单同步推送到班级群里，家长点击后只能看到自己孩子的信息
            </span>
          </div>
        </div>
        <div style="width:98%;height:1px;margin: auto;background-color: #eee"></div>
        <div class="feature-text">
          <span></span>
          <span>特色功能</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FeatureNavMenu from '../../../components/FeatureNavMenu.vue'
export default {
  components: {
    FeatureNavMenu
  },
  data() {
    return {
      navMenus: [
        {title: '教 学 管 理', features: ['成绩管理及分析', '教学评语', '校内留言']},
        {title: '家 校 互 动', features: ['校内公告', '校内资讯', '接龙任务']},
        {title: '德 育 管 理', features: ['优秀班级评定', '考勤管理', '日常评定']},
        {title: '综 合 素 质 评 价', features: ['学生操行评定', '学生评定加减分']}
      ],
      featureImgs: [
        require('../../../assets/feature1.png')
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.product {
  .title {
    margin: 0;
    padding: 20px;
    background-color: #eee;
    font-size: 16px;
    font-weight: 500
  }
  .content {
    overflow: hidden;
    // width: 80%;
    margin: auto;
    .left {
      float: left;
      width: 25%;
    }
    .right{
      width: 70%;
      float: left;
      margin-top: 18px;
      border: 1px solid #eee;
    }
  }
}
.header {
  overflow: hidden;
  display: flex;
  padding: 20px;
  div {
    overflow: hidden;
    &:nth-child(1) {
      flex: 2;
      display: flex;
      align-items: center;
      img {
        float: left;
      }
      div {
        width: 60%;
        height: 80px;
        float: left;
        text-align: left;
        margin-left: 20px;
        font-size: 12px;
        display: table;
        p {
          display: table-cell;
          vertical-align: middle;
          span {
            &:nth-child(1) {
              font-weight: 500;
              font-size: 16px;
            }
          }
        }

      }
    }
    &:nth-child(3) {
      flex: 3;
      width: 380px;
      font-size: 12px;
      text-align: left;
      display: table;
      height: 80px;
      span {
        display: table-cell;
        vertical-align: middle;
        text-align: left;
      }
    }
  }
}
.feature-text {
  text-align: left;
  overflow: hidden;
  height: 30px;
  padding: 20px;
  span {
    display: inline-block;
    overflow: hidden;
    line-height: 30px;
    font-size: 16px;
    &:nth-child(1) {
      width: 5px;
      height: 30px;
      background-color: #a0d36e;
    }
    &:nth-child(2) {
      margin-left: 15px;
      font-weight: 500;
    }
  }
}
</style>

